export default "__VITE_ASSET__MqHrMnvo__"